// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { meditationAPI } from '../../services/meditationAPI';

const PublicSharePage: React.FC = () => {
  const { id } = useParams();
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/meditations/public/${id}`);
        if (!res.ok) throw new Error('불러오기 실패');
        const json = await res.json();
        if (!json?.success) throw new Error('불러오기 실패');
        setData(json.meditation);
      } catch (e: any) {
        setError(e?.message || '불러오기 실패');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) return <div className="p-6 text-center">불러오는 중...</div>;
  if (error) return <div className="p-6 text-center text-red-600">{error}</div>;
  if (!data) return null;

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-bold">공유된 묵상</h1>
      <div className="bg-white rounded-xl shadow p-5">
        <div className="text-sm text-slate-500 mb-2">작성자: {data.user?.name || '익명'}</div>
        {data.verseReference && (
          <div className="mb-2 font-semibold">📖 {data.verseReference}</div>
        )}
        {data.verseText && <div className="mb-3 text-slate-700">{data.verseText}</div>}
        {data.godsWill && (
          <div className="mb-3">
            <div className="text-slate-500 text-sm">하나님의 뜻</div>
            <div>{data.godsWill}</div>
          </div>
        )}
        {data.growthChange && (
          <div className="mb-3">
            <div className="text-slate-500 text-sm">성장/변화</div>
            <div>{data.growthChange}</div>
          </div>
        )}
        {data.prayer && (
          <div className="mb-3">
            <div className="text-slate-500 text-sm">기도</div>
            <div>{data.prayer}</div>
          </div>
        )}
      </div>

      {/* 행동 유도: 로그인/회원가입 + 서비스 둘러보기 */}
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <div className="font-semibold mb-2">더 많은 기능을 사용하려면 로그인하세요</div>
        <div className="flex gap-3">
          <Link to="/" className="px-4 py-2 bg-blue-600 text-white rounded-lg">로그인/회원가입</Link>
          <Link to="/" className="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg">서비스 둘러보기</Link>
        </div>
      </div>
    </div>
  );
};

export default PublicSharePage;


